import { toast } from '@/components/ui/toast';
import type { RecommendFriend } from '@/features/check-in/types';
import { useRecommendToFriend } from '@/features/friend-recommendations/hooks/use-recommend-to-friend';
import { useCallback } from 'react';

export function useMenuItemRecommendActions(menuItemId: string) {
  const { mutate } = useRecommendToFriend();

  const handleSendRecommendations = useCallback(
    (selected: RecommendFriend[]) => {
      for (const friend of selected) {
        mutate({ recipient_id: friend.id, menu_item_id: menuItemId });
      }
      if (selected.length > 0) {
        toast.success(
          selected.length === 1
            ? 'Recommendation sent'
            : `${selected.length} recommendations sent`,
        );
      }
    },
    [mutate, menuItemId],
  );

  return { handleSendRecommendations };
}
